<div class="picker-flat">

  @if (showSearch()) {
    <div class="search-wrap">
      <svg class="search-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <circle cx="11" cy="11" r="7"/>
        <path d="M21 21l-4.35-4.35"/>
      </svg>
      <input
        class="search-input"
        type="text"
        placeholder="Search…"
        [value]="searchText()"
        (input)="onSearchInput($any($event.target).value)"
        aria-label="Search options"
      />
    </div>
  }

  <ul class="checklist" role="listbox" aria-multiselectable="true">
    @for (opt of filteredOptions(); track opt) {
      <li
        class="option"
        role="option"
        [class.on]="selected().includes(opt)"
        [attr.aria-selected]="selected().includes(opt)"
        (click)="toggle(opt)"
      >
        <span class="cb" aria-hidden="true">{{ selected().includes(opt) ? '✓' : '' }}</span>
        <span class="label">{{ opt }}</span>
      </li>
    } @empty {
      <li class="empty">No matches.</li>
    }
  </ul>

</div>
